import { graphql } from 'react-relay';
import Cookies from 'js-cookie';
import { localStorage, sessionStorage } from 'dibs-browser-storage';
import { isMasquerading, cookieJarConstants } from 'dibs-cookie-jar';
import { sourceAttributionMutation } from './sourceAttributionMutation';
import { userProfileMutation } from '../mutations/userProfileMutation';
import { getMeasurementUnit } from 'dibs-intl/exports/intlSupport';
import { getCurrencyPreference } from '../../utils/preferredCurrency';
import { getGuestId, deleteGuestId } from '../../utils/guestIdStorage';
import { checkHoldoutGroup } from '../../helpers/checkHoldoutGroup';
import serverVars from 'server-vars';
import * as constants from './userStorageConstants';
import {
    getSourceAttribution,
    clearSourceAttribution,
} from 'dibs-visit-tracking/exports/sourceAttribution';
import { GUEST_CHECKOUT } from '../../utils/userTracking';

function clearGuestCheckoutEntry() {
    sessionStorage.deleteItem(GUEST_CHECKOUT);
}

// Do not write client-side cookies for long-term storage!! see https://1stdibs.atlassian.net/browse/ENGAGE-979
// submits guestId to sourceAttribution call and adds user data to localStorage
export function setTokens(payload = {}) {
    const { environment, user, emailToken, userId, userToken } = payload;

    const { profile = {} } = user || {};
    const guestUserId = getGuestId();

    if (guestUserId && !isMasquerading(document.cookie)) {
        sourceAttributionMutation(environment, {
            guestUserId,
            type: constants.GUEST_USER,
            userId,
            userToken,
            emailToken,
            pageVisits: getSourceAttribution(),
        });
        deleteGuestId();
    }
    clearSourceAttribution();
    clearGuestCheckoutEntry();

    if (profile.email) {
        localStorage.setItem(constants.USER_EMAIL, profile.email);
    }
    if (emailToken) {
        localStorage.setItem(constants.USER_EMAIL_TOKEN, emailToken);
    }
}

export async function setHomepageUserGroup(payload = {}) {
    const { environment, userId } = payload;
    if (userId) {
        const homepageUserGroup = await checkHoldoutGroup(environment, userId);
        Cookies.set(cookieJarConstants.HOMEPAGE_USER_GROUP, homepageUserGroup);
    }
}

export function resetVisitCount() {
    const visitCount = localStorage.getItem(constants.VISIT_COUNT) || {};
    const { regPromptLimit = constants.REG_PROMPT_LIMIT, totalVisitCount = 0 } = visitCount;
    localStorage.setItem(constants.VISIT_COUNT, {
        totalVisitCount,
        sinceRegPrompt: 0,
        regPromptLimit,
    });
}

export function updateProfile(payload) {
    const { environment, userId } = payload;
    const locale = serverVars.get('locale');
    const currency = getCurrencyPreference();
    const measurementUnit = getMeasurementUnit(locale);
    return new Promise(resolve => {
        userProfileMutation(environment, {
            currency,
            measurementUnit,
            userServiceId: userId,
            onCompleted: () => {
                resolve(payload);
            },
            // don't reject - if this mutation fails do not show the user an error
            onError: () => resolve(payload),
        });
    });
}

export const userTrackingFragment = graphql`
    fragment userStorageActions on User {
        isVerifiedTrade
        isVip
    }
`;
